import React, { useState } from 'react';
import { Box, FormLabel, Input } from '@mui/joy';
import { Button } from '../..';
import { useTranslation } from 'react-i18next';
import { useDataProvider } from 'src/mtska-frontend-data-provider';



const WidtgetTokenGenerator = (params) => {
    const { t } = useTranslation();
    const [token, setToken] = useState();
    const { loadOne } = useDataProvider('auth/user/newToken');

    const requestToken = () => {
        loadOne(params.item._id).then((res) => {
            console.info(res.item.token)
            setToken(res.item.token)
        })
    }

    return <>
        <FormLabel className="form-element-label">API Access</FormLabel>
        <Box className="form-element col-12 tokenGeneratorWrapper">
            {
                !token && <>
                    <span>{t('Generate a token to access the API Layer with this user. Be aware that any previously generated token will stop working.')}</span>
                    <Button onClick={requestToken}>{t('Generate')}</Button>
                </>
            }
            {
                token && <>
                    <span>{t('This is your token, copy and store it in a safe place (you will never see it again here).')}</span>
                    <Input
                        value={token}
                        variant="outlined"
                        autoComplete="off"
                        className="form-element-field"
                    />
                </>
            }
        </Box>
    </>
}

export default WidtgetTokenGenerator



